var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.779 29.565C119.779 31.9998 119.808 34.0706 119.443 35.9061C118.059 42.8596 112.624 48.2952 105.67 49.6783C103.959 50.0189 102.044 50.0171 99.8191 50.0154C74.1734 49.9951 48.5269 49.9951 22.881 50.0154C20.6566 50.0171 18.7411 50.0189 17.03 49.6783C10.0765 48.2952 4.6409 42.8596 3.25776 35.9061C2.89264 34.0706 2.92092 31.9998 2.92092 29.5649C2.92092 27.1301 2.89264 25.0593 3.25776 23.2238C4.6409 16.2703 10.0765 10.8347 17.03 9.45158C18.7411 9.11123 20.6566 9.11275 22.881 9.11451C48.5269 9.13496 74.1734 9.13496 99.8191 9.11451C102.044 9.11275 103.959 9.11123 105.67 9.45158C112.624 10.8347 118.059 16.2703 119.443 23.2238C119.808 25.0593 119.779 27.1301 119.779 29.565Z",
    fill: "url(#paint0_linear_341_2361)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.76442 85.4567V52.7282C10.939 53.9838 13.3373 54.9006 15.8889 55.4083C18.1775 55.8635 20.603 55.8606 22.616 55.8582L22.8845 55.8577C48.5273 55.8372 74.1706 55.8372 99.8133 55.8577L100.082 55.8582C102.094 55.8606 104.52 55.8635 106.809 55.4083C109.362 54.9006 111.762 53.9833 113.937 52.7264V85.4567C113.937 90.6364 113.937 95.0992 113.457 98.6733C112.942 102.503 111.781 106.175 108.803 109.153C105.825 112.131 102.153 113.292 98.3234 113.807C94.7493 114.287 90.2865 114.287 85.1067 114.287H37.5943C32.4147 114.287 27.9518 114.287 24.3779 113.807C20.5478 113.292 16.8764 112.131 13.8985 109.153C10.9206 106.175 9.75935 102.503 9.24441 98.6733C8.76389 95.0992 8.76413 90.6364 8.76442 85.4567ZM43.8219 61.7012C40.595 61.7012 37.979 64.317 37.979 67.5441C37.979 70.7711 40.595 73.387 43.8219 73.387H78.8794C82.1064 73.387 84.7223 70.7711 84.7223 67.5441C84.7223 64.317 82.1064 61.7012 78.8794 61.7012H43.8219Z",
    fill: "url(#paint1_linear_341_2361)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_341_2361",
    x1: 0.952255,
    y1: 51.4341,
    x2: 87.686,
    y2: -25.7424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C75BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454839,
    stopColor: "#1C75BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27AAE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_341_2361",
    x1: 6.99308,
    y1: 116.422,
    x2: 115.998,
    y2: 58.4232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C75BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454839,
    stopColor: "#1C75BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27AAE1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveIcon);
export default __webpack_public_path__ + "static/media/archive-icon.945c265ad997628f2a25be09643c459a.svg";
export { ForwardRef as ReactComponent };